// removed by extract-text-webpack-plugin
module.exports = {"infoBlock":"_3tXKLrXLruc_jLYKAIBg5Q","nameCompany":"_2JucWpBazuGqbILYgx7az1","description":"RCfnPAygv2vpiBgyHoG2R","descriptionWrapper":"_3d5diG9_ySNZG6fz1Hrlx0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyInPropertiesList/CompanyDescription/CompanyDescription.scss
// module id = 1582
// module chunks = 0